export default __webpack_public_path__ + "static/media/38_mobile.a3d64635.jpg";